<div class="col-lg-12 col-md-12 col-sm-12" style="padding:0px">

  <div class="row margin0px" style="padding:0px" >
    <div class="col-lg-2 col-md-2 col-sm-2">
      <span class="dx-field-label">Qualitative Factors</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Original Value</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Adjusted Value</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Score (SC)</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Weight (SW)</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:center;">
      <span class="dx-field-label">Weighted Score</span>
    </div>
  </div>

  <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px">
    <div *ngFor="let group of __oQualitativeGroup">

      <fieldset style="margin:5px;">
        <legend>{{group.GroupName}}</legend>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView">
            <div *ngIf="group.GroupName == item.GroupName" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <span>{{item.QualitativeFactor}}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView; let i=index"  style="text-align:center;">
            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Text Box'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <dx-text-area [height]="30" [readOnly]="__sQualitativeControlState != 'Not Approve State' || __bReadOnly === 1" [maxLength]="500" [(value)]="item.OriginalValue" (onChange)="TextAreaOnChangeOriginal(item.lFAScoringModelQualitativeId)"></dx-text-area>
            </div>

            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Multiline TextBox'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <dx-text-area [height]="50" [readOnly]="__sQualitativeControlState != 'Not Approve State' || __bReadOnly === 1" [maxLength]="5000" [(value)]="item.OriginalValue" (onChange)="TextAreaOnChangeOriginal(item.lFAScoringModelQualitativeId)"></dx-text-area>
            </div>

            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Combo Box'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <dx-select-box 
                             [dataSource]="item.ItemSourceJSON"
                             displayExpr="DisplayMember"
                             valueExpr="DisplayMember"
                             [(value)]="item.OriginalValue"
                             (onSelectionChanged)="TextAreaOnChangeOriginal(item.lFAScoringModelQualitativeId)"
                             [searchEnabled]="true"
                             style="height:30px;"
                             [readOnly]="__sQualitativeControlState != 'Not Approve State' || __bReadOnly === 1">
              </dx-select-box>
            </div>
            <!--<div *ngIf="group.GroupName == item.GroupName" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <span>{{item.OriginalValue}}</span>
            </div>-->
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView; let i=index">

            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Text Box'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;" >
              <dx-text-area  [height]="30" [readOnly]="__sQualitativeControlState == 'Not Approve State' || __bReadOnly === 1" [maxLength]="500" [(value)]="item.AdjustedValue" (onChange)="TextAreaOnChange(item.lFAScoringModelQualitativeId)"></dx-text-area>
            </div>

            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Multiline TextBox'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <dx-text-area [height]="50" [readOnly]="__sQualitativeControlState == 'Not Approve State' || __bReadOnly === 1" [maxLength]="5000" [(value)]="item.AdjustedValue" (onChange)="TextAreaOnChange(item.lFAScoringModelQualitativeId)"></dx-text-area>
            </div>

            <div *ngIf="group.GroupName == item.GroupName && item.CustomPropertyDisplayType =='Combo Box'" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px'}" style="margin:2px;">
              <dx-select-box 
                             [dataSource]="item.ItemSourceJSON"
                             displayExpr="DisplayMember"
                             valueExpr="DisplayMember"
                             [(value)]="item.AdjustedValue"
                             (onSelectionChanged)="TextAreaOnChange(item.lFAScoringModelQualitativeId)"
                             [searchEnabled]="true"
                             style="height:30px;"
                             [readOnly]="__sQualitativeControlState == 'Not Approve State' || __bReadOnly === 1">
              </dx-select-box>              
            </div>

          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView">
            <div *ngIf="group.GroupName == item.GroupName" style="margin:2px;" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px','visibility':item.IsScored === 1 ? 'visible':'hidden'}">
              <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Score" [disabled]="true" style="text-align:right;"></dx-number-box>              
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView">
            <div *ngIf="group.GroupName == item.GroupName" style="margin:2px;" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px','visibility':item.IsScored === 1 ? 'visible':'hidden'}">
              <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.Weight" [disabled]="true" style="text-align:right;"></dx-number-box>              
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-2">
          <div *ngFor="let item of __oFAScoringModelQualitativeView">
            <div *ngIf="group.GroupName == item.GroupName" style="margin:2px;" [ngStyle]="{'height':item.CustomPropertyDisplayType != 'Multiline TextBox' ? '40px':'55px','visibility':item.IsScored === 1 ? 'visible':'hidden'}">
              <dx-number-box [step]="0" format="#,##0.00" [(value)]="item.WeightedScore" [disabled]="true" style="text-align:right;"></dx-number-box>             
            </div>
          </div>
        </div>

      </fieldset>
    </div>
  </div>


</div>
<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>
